import React from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import PageHeader from "../../components/ui/PageHeader";
import PageTransition from "../../components/ui/PageTransition";
import LeaveRequests from "../LeaveRequests/LeaveRequests";
import LeaveSettings from "../LeaveSettings/LeaveSettings";
import LeaveBalances from "./LeaveBalances";

const TABS = ["requests", "types", "balance"];

// One Leave module: requests, types and the balance of every employee.
const Leave = () => {
  const [params, setParams] = useSearchParams();
  const tab = TABS.includes(params.get("tab")) ? params.get("tab") : "requests";

  const items = [
    { key: "requests", label: "Requests", children: <LeaveRequests embedded /> },
    { key: "types", label: "Types", children: <LeaveSettings section="types" /> },
    { key: "balance", label: "Balance", children: <LeaveBalances /> },
  ];

  return (
    <PageTransition>
      <PageHeader title="Leave" subtitle="Requests, leave types, and the leave balance of every employee" />
      <Tabs activeKey={tab} onChange={(k) => setParams({ tab: k }, { replace: true })} items={items} destroyInactiveTabPane />
    </PageTransition>
  );
};

export default Leave;
